import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"margin-top":"10px"} }
const _hoisted_2 = ["href"]
const _hoisted_3 = { style: {"max-height":"150px","overflow":"scroll","padding":"8px"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_6 = { class: "spin ion-text-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              (!_ctx.hideHeader)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "start"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        slot: "icon-only",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_searchbar, {
                style: {"padding-bottom":"0","height":"40px"},
                mode: "ios",
                modelValue: _ctx.searchKeyword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKeyword) = $event)),
                "show-cancel-button": "focus"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (!_ctx.hideHeader)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
                default: _withCtx(() => [
                  (_ctx.nominatingEvent || _ctx.service)
                    ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _cache[11] || (_cache[11] = _createElementVNode("p", null, [
                                _createTextVNode("Our programs use a "),
                                _createElementVNode("b", null, "Real Name system"),
                                _createTextVNode(" (實名制), with "),
                                _createElementVNode("b", null, "certificates"),
                                _createTextVNode(" issued jointly by universities and FDMT.")
                              ], -1)),
                              _createElementVNode("p", _hoisted_1, [
                                _cache[9] || (_cache[9] = _createTextVNode("After students register (by scanning the QR code at ")),
                                _createElementVNode("a", {
                                  target: "_blank",
                                  href: _ctx.service.slideLink
                                }, _toDisplayString(_ctx.service.slideLink.replace("https://", "")), 9, _hoisted_2),
                                _cache[10] || (_cache[10] = _createTextVNode("), they are listed below for you to:"))
                              ]),
                              _cache[12] || (_cache[12] = _createElementVNode("p", null, [
                                _createElementVNode("ol", null, [
                                  _createElementVNode("li", null, "Verify (and edit here if needed) their mobile and name spelling for certificate issues, etc"),
                                  _createElementVNode("li", null, "Nominate them by checking the corresponding box")
                                ])
                              ], -1)),
                              _cache[13] || (_cache[13] = _createElementVNode("p", null, "We hope this saves teachers' eForm-creating efforts in pre-nomination data collection.", -1))
                            ]),
                            _: 1,
                            __: [11,12,13]
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_title, {
                        key: 1,
                        style: {"padding-left":"0"},
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            size: "small",
                            class: "no-text-transform",
                            fill: "outline",
                            color: "success",
                            href: `https://fdmt.hk/r/${_ctx.schoolId}`,
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _cache[14] || (_cache[14] = _createTextVNode(" Registered student report ")),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.openOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1,
                            __: [14]
                          }, 8, ["href"])
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_chip, {
                    class: _normalizeClass({ 'active-tag': _ctx.selectedFilter == 'all' || _ctx.searchKeyword }),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedFilter = 'all')),
                    color: _ctx.selectedFilter == 'all' ? '' : 'medium'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("All")
                        ])),
                        _: 1,
                        __: [15]
                      })
                    ]),
                    _: 1
                  }, 8, ["class", "color"]),
                  (_ctx.nominatingEvent == null)
                    ? (_openBlock(), _createBlock(_component_ion_chip, {
                        key: 0,
                        class: _normalizeClass({ 'active-tag': _ctx.selectedFilter == 'unverified' }),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedFilter = 'unverified')),
                        color: _ctx.selectedFilter == 'unverified' ? '' : 'medium'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("Unverified")
                            ])),
                            _: 1,
                            __: [16]
                          })
                        ]),
                        _: 1
                      }, 8, ["class", "color"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_component_ion_chip, {
                          class: _normalizeClass({ 'active-tag': _ctx.selectedFilter == 'applied' }),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedFilter = 'applied')),
                          color: _ctx.selectedFilter == 'applied' ? '' : 'medium'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("Applied")
                              ])),
                              _: 1,
                              __: [17]
                            })
                          ]),
                          _: 1
                        }, 8, ["class", "color"])
                      ])),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allClasses(_ctx.schoolStudents), (studentClass) => {
                    return (_openBlock(), _createBlock(_component_ion_chip, {
                      key: studentClass,
                      class: _normalizeClass({ 'active-tag': _ctx.selectedFilter == studentClass }),
                      onClick: ($event: any) => (_ctx.selectedFilter = studentClass || ''),
                      color: _ctx.selectedFilter == studentClass ? '' : 'medium'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(studentClass), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick", "color"]))
                  }), 128))
                ]),
                (!_ctx.nominatingEvent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Are they students at your school? "))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_ion_buttons, { slot: "end" }, {
                  default: _withCtx(() => [
                    (_ctx.nominees.every(n => (['Yes', 'Confirmed'].includes(_ctx.getStudentSessionResp(n)))))
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 0,
                          size: "small",
                          fill: "solid",
                          class: "no-text-transform",
                          color: "danger",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitNomination('No')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.close
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createElementVNode("h3", null, "Reject", -1)
                              ])),
                              _: 1,
                              __: [18]
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      fill: "solid",
                      class: "no-text-transform",
                      color: "success",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitNomination()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createElementVNode("h3", null, "Nominate", -1)
                          ])),
                          _: 1,
                          __: [19]
                        }),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.arrowForward
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.nominees.length > 0]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.section == 2]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, [
                _createElementVNode("img", {
                  width: "200",
                  src: _ctx.getQRCodeUrl(`https://ab.fdmt.hk/s/${_ctx.user.schoolId}`)
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("p", null, "ab.fdmt.hk/s/" + _toDisplayString(_ctx.user.schoolId), 1),
              _createVNode(_component_ion_button, {
                size: "small",
                color: "success",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sendLinkToMyWhatsApp(`https://ab.fdmt.hk/s/${_ctx.user.schoolId}`, _ctx.user.phone, _ctx.user.waGroupId)))
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode(" Send to my WhatsApp ")
                ])),
                _: 1,
                __: [20]
              })
            ])
          ], 512), [
            [_vShow, _ctx.section == 1]
          ]),
          _withDirectives(_createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              (_ctx.nominatingEvent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSchoolStudents().slice(0, _ctx.numOfVisibleItems), (student) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        lines: "full",
                        key: student.phone
                      }, {
                        default: _withCtx(() => [
                          (['Yes', 'Confirmed', 'Attended'].includes(_ctx.getStudentSessionResp(student)) && _ctx.getStudentSessionResp(student, 'nominatedBy'))
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 0,
                                slot: "start",
                                icon: _ctx.checkmark,
                                style: {"margin-inline-end":"16px"}
                              }, null, 8, ["icon"]))
                            : (_openBlock(), _createBlock(_component_ion_checkbox, {
                                key: 1,
                                slot: "start",
                                "onUpdate:modelValue": ($event: any) => (_ctx.onCheckNominee($event, student)),
                                modelValue: _ctx.nominees.find(n => n.id == student.id) != null,
                                style: {"margin-inline-end":"16px"},
                                disabled: _ctx.isDisableNomination(student)
                              }, null, 8, ["onUpdate:modelValue", "modelValue", "disabled"])),
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(student.class) + _toDisplayString(_ctx.formatStudentNumber(student.studentNumber)) + " " + _toDisplayString(student.fullName) + " " + _toDisplayString(student.chineseName) + _toDisplayString(student.preferredName ? ` (${student.preferredName})` : ''), 1),
                              _createElementVNode("p", null, [
                                _createTextVNode("DSE " + _toDisplayString(student.yearDSE) + " | " + _toDisplayString(student.phone), 1),
                                (student.email)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " | " + _toDisplayString(student.email), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (student.isNewStudent)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    _createVNode(_component_ion_badge, { color: "secondary" }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode("New")
                                      ])),
                                      _: 1,
                                      __: [21]
                                    }),
                                    _cache[22] || (_cache[22] = _createTextVNode(" "))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isStudentAttendedBefore(student))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                    _createVNode(_component_ion_badge, { color: "success" }, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createTextVNode("Attended before")
                                      ])),
                                      _: 1,
                                      __: [23]
                                    }),
                                    _cache[24] || (_cache[24] = _createTextVNode(" "))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.getStudentSessionResp(student))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                    (_ctx.getStudentSessionResp(student, 'nominatedBy'))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                          (_ctx.getStudentSessionResp(student) == 'No')
                                            ? (_openBlock(), _createBlock(_component_ion_badge, {
                                                key: 0,
                                                color: "danger"
                                              }, {
                                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                  _createTextVNode("Rejected")
                                                ])),
                                                _: 1,
                                                __: [25]
                                              }))
                                            : (_openBlock(), _createBlock(_component_ion_badge, {
                                                key: 1,
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                  _createTextVNode("Nominated")
                                                ])),
                                                _: 1,
                                                __: [26]
                                              })),
                                          _cache[27] || (_cache[27] = _createTextVNode("  "))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (['Attended', 'Yes', 'Confirmed'].includes(_ctx.getStudentSessionResp(student)))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                          _createVNode(_component_ion_badge, { color: "primary" }, {
                                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                                              _createTextVNode("Applied")
                                            ])),
                                            _: 1,
                                            __: [28]
                                          }),
                                          _cache[29] || (_cache[29] = _createTextVNode(" "))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (['Attended'].includes(_ctx.getStudentSessionResp(student)))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                          _createVNode(_component_ion_badge, { color: "success" }, {
                                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                                              _createTextVNode("Attended")
                                            ])),
                                            _: 1,
                                            __: [30]
                                          }),
                                          _cache[31] || (_cache[31] = _createTextVNode(" "))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (['Unsubscribed'].includes(_ctx.getStudentSessionResp(student)))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                          _createVNode(_component_ion_badge, { color: "danger" }, {
                                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                                              _createTextVNode("Unsubscribed")
                                            ])),
                                            _: 1,
                                            __: [32]
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (['No'].includes(_ctx.getStudentSessionResp(student)))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                          _createVNode(_component_ion_badge, { color: "danger" }, {
                                            default: _withCtx(() => _cache[33] || (_cache[33] = [
                                              _createTextVNode("Withdrawn")
                                            ])),
                                            _: 1,
                                            __: [33]
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.nominatingEvent.needInterview && ['Attended', 'Yes', 'Confirmed'].includes(_ctx.getStudentSessionResp(student)))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                    (_ctx.getInterviewSessionResp(student))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                          (_ctx.getInterviewSessionResp(student, 'interviewStatus').includes('Accepted') )
                                            ? (_openBlock(), _createBlock(_component_ion_badge, {
                                                key: 0,
                                                color: "success"
                                              }, {
                                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                                  _createTextVNode("Interview passed")
                                                ])),
                                                _: 1,
                                                __: [34]
                                              }))
                                            : _createCommentVNode("", true),
                                          _cache[36] || (_cache[36] = _createTextVNode("  ")),
                                          (_ctx.getInterviewSessionResp(student, 'interviewStatus').includes('Rejected') )
                                            ? (_openBlock(), _createBlock(_component_ion_badge, {
                                                key: 1,
                                                color: "danger"
                                              }, {
                                                default: _withCtx(() => _cache[35] || (_cache[35] = [
                                                  _createTextVNode("Interview failed")
                                                ])),
                                                _: 1,
                                                __: [35]
                                              }))
                                            : (_openBlock(), _createBlock(_component_ion_badge, {
                                                key: 2,
                                                color: "tertiary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getInterviewSessionResp(student, 'statusText')), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                          _createVNode(_component_ion_badge, { color: "medium" }, {
                                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                                              _createTextVNode("Interview to be confirmed")
                                            ])),
                                            _: 1,
                                            __: [37]
                                          })
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                size: "small",
                                onClick: ($event: any) => (_ctx.openUserProfileFormModal(student))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.pencil
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSchoolStudents().slice(0, _ctx.numOfVisibleItems), (student) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        lines: "full",
                        key: student.phone
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(student.class) + _toDisplayString(_ctx.formatStudentNumber(student.studentNumber)) + " " + _toDisplayString(student.chineseName), 1),
                              _createElementVNode("p", null, _toDisplayString(student.fullName) + _toDisplayString(student.preferredName ? ` (${student.preferredName})` : ''), 1),
                              _createElementVNode("p", null, [
                                _createTextVNode(_toDisplayString(student.phone), 1),
                                (student.email)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, " | " + _toDisplayString(student.email), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          (_ctx.nominatingEvent == null)
                            ? (_openBlock(), _createBlock(_component_ion_chip, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.updateUserVerificationResult('Yes', student)),
                                outline: student.verificationResult != 'Yes'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                                      _createTextVNode("Yes")
                                    ])),
                                    _: 1,
                                    __: [38]
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick", "outline"]))
                            : _createCommentVNode("", true),
                          (_ctx.nominatingEvent == null)
                            ? (_openBlock(), _createBlock(_component_ion_chip, {
                                key: 1,
                                onClick: ($event: any) => (_ctx.updateUserVerificationResult('No', student)),
                                outline: student.verificationResult != 'No'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                      _createTextVNode("No")
                                    ])),
                                    _: 1,
                                    __: [39]
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick", "outline"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])),
              _createVNode(_component_ion_infinite_scroll, {
                onIonInfinite: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadData($event))),
                threshold: "100px",
                id: "infinite-scroll"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_infinite_scroll_content, {
                    "loading-spinner": "bubbles",
                    "loading-text": "Loading..."
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.section == 2]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}